import * as React from 'react';
import { Confirmation } from '../../components/molecules/Confirmation.mjs';
import { useMountEffect } from '../../hooks/useMountEffect.mjs';
import { useEventCallback } from '../GlobalContextProvider.mjs';
import { StytchEventType } from '../../../../../core/src/public/ui.mjs';

const ConfirmationScreen = ()=>{
    const onEvent = useEventCallback();
    useMountEffect(()=>{
        onEvent({
            type: StytchEventType.AuthenticateFlowComplete,
            data: {}
        });
    });
    return /*#__PURE__*/ React.createElement(Confirmation, null);
};

export { ConfirmationScreen };
//# sourceMappingURL=Confirmation.mjs.map
